import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import useExtendedState from '../../hooks/useExtendedState';
import SaveButton from '../buttons/SaveButton';
import TextField from '../fields/TextField';
import useExtendedMutation from '../../hooks/useExtendedMutation';
import {
    SUBMARKET_CODE_MAX_LENGTH,
    SUBMARKET_NAME_MAX_LENGTH,
    submarketCodeValidator,
    submarketNameValidator,
} from '../../validators/submarkets';
import useMultiValidator from '../../hooks/useMultiValidator';
import { ALL_SUBMARKETS_QUERY_NAME, CREATE_SUBMARKET } from '../../graphql/submarkets';
import ExpandedListTab from '../ExpandedListTab';
import { compositeValidator, wafValidator } from '../../hooks/validationSupport';

SubmarketCreateTab.propTypes = {
    hideHandler: PropTypes.func.isRequired,
};

function SubmarketCreateTab(props) {
    const { hideHandler } = props;
    const { t } = useTranslation();
    const nameState = useExtendedState('');
    const codeState = useExtendedState('');
    const { validators, isValid } = useMultiValidator(false, {
        name: compositeValidator(submarketNameValidator(t), wafValidator(t)),
        code: compositeValidator(submarketCodeValidator(t), wafValidator(t)),
    });
    const [isDisabled, setIsDisabled] = useState(true);
    isValid()
        .then(() => setIsDisabled(false))
        .catch(() => setIsDisabled(true));

    const extendedMutation = useExtendedMutation(CREATE_SUBMARKET, {
        variables: {
            code: codeState.value,
            name: nameState.value,
        },
        successCallback: hideHandler,
        successMessageOptions: { key: 'submarkets.notification.submarket-create-success', dataProperty: 'createSubmarket' },
        failureMessageOptions: { key: 'submarkets.notification.submarket-create-failure', params: { name: nameState.value, code: codeState.value } },
        refetchQueries: [ALL_SUBMARKETS_QUERY_NAME],
    });
    return (
        <ExpandedListTab
            className="submarket-create-tab"
            title={t('submarkets.submarket-detail')}
        >
            <div className="rich-list-row-expanded--fields">
                <TextField
                    label={t('submarkets.name')}
                    state={nameState}
                    className="submarket-create-tab--fields--name wide"
                    validator={validators.name}
                    placeholder={t('submarkets.placeholder.name')}
                    maxLength={SUBMARKET_NAME_MAX_LENGTH}
                    isRequired
                />
                <TextField
                    label={t('submarkets.code')}
                    state={codeState}
                    className="submarket-create-tab--fields--code"
                    validator={validators.code}
                    placeholder={t('submarkets.placeholder.code')}
                    maxLength={SUBMARKET_CODE_MAX_LENGTH}
                    isRequired
                />
            </div>
            <div className="rich-list-row-expanded--buttons">
                <SaveButton extendedMutation={extendedMutation} disabled={isDisabled} confirmationMessage={t('submarkets.confirm-create-submarket', { name: nameState.value, code: codeState.value })} />
            </div>
        </ExpandedListTab>
    );
}

export default SubmarketCreateTab;
